import { Component, OnInit, OnDestroy } from '@angular/core';
import { BreadcrumbService } from '../../shared/breadcrumb/breadcrumb.service';
import { NotificationMessageService } from '../../shared/notification-message/notification-message.service';
import { NavigationService } from '../../shared/services/navigation.service';
import { Router, ActivatedRoute } from '@angular/router';
import { HomeService } from '../home.service';
import { UserService } from '../../auth/user.service';
import { User } from '../../auth/user.model';
import { AuthService } from '../../auth/auth.service';
import { HeaderService } from '../../shared/header/header.service';
import { FooterService } from '../../shared/footer/footer.service';

@Component({
	selector: 'app-change-password',
	templateUrl: './change-password.component.html',
	styleUrls: ['./change-password.component.css']
})
export class ChangePasswordComponent implements OnInit, OnDestroy {

	URLparameters: any = {};
	pageName = '';
	mode: string = 'normal';
	user: {
		oldPassword: string,
		newPassword: string,
		confirmPassword: string,
		id: number
	} = {
		oldPassword: null,
		newPassword: null,
		confirmPassword: null,
		id: 0
	};
	// AW-50: Password policy validation
	passwordValidationErrors: string[] = [];
	forbiddenWords: string[] = ['act', 'motive', 'actview', 'battview', 'actlink', 'motiveenergy'];
	isExpired: boolean = false;
	resetLinkSent: boolean = false;

	constructor(
		private authService: AuthService,
		private homeService: HomeService,
		private breadcrumb: BreadcrumbService,
		private notificationMessage: NotificationMessageService,
		public navigation: NavigationService,
		private route: ActivatedRoute,
		private router: Router,
		private header: HeaderService,
		private userService: UserService,
		private footer: FooterService,
	) {
	}

	ngOnInit() {

		this.pageName = this.route.snapshot.data['pageName'];
		this.user.id = this.userService.getCurrentUser().id;

		switch(this.pageName) {
			case 'reset_password':
				this.header.hide();
				this.user.id = this.route.snapshot.params['userId'];
				this.route.queryParams.subscribe( params => {
					this.URLparameters = params || {};
				});
			break;
			case 'change_password':
				// after login
				this.header.hide();
				this.breadcrumb.hide();
				this.footer.hide();
				const routeUserId = this.route.snapshot.params['userId'];
				if (routeUserId) {
					this.user.id = parseInt(routeUserId, 10);
				}
				this.route.queryParams.subscribe(params => {
					this.isExpired = params['expired'] === 'true';
				});
				this.mode = 'register';
			break;
			case 'change_user_password':
				// from header
				this.breadcrumb.setBreadcrumb([{label: 'Change Password', url: ''}]);
			break;
		}
	}

	// AW-50: Client-side password policy validation
	validatePasswordPolicy() {
		const errors: string[] = [];
		const password = this.user.newPassword;

		if (!password) {
			this.passwordValidationErrors = [];
			return;
		}

		// 1. Check minimum length (12 characters)
		if (password.length < 12) {
			errors.push('Password must be at least 12 characters long');
		}

		// 2. Check for at least one uppercase letter
		if (!/[A-Z]/.test(password)) {
			errors.push('Password must contain at least one uppercase letter');
		}

		// 3. Check for at least one lowercase letter
		if (!/[a-z]/.test(password)) {
			errors.push('Password must contain at least one lowercase letter');
		}

		// 4. Check for at least one digit
		if (!/[0-9]/.test(password)) {
			errors.push('Password must contain at least one digit');
		}

		// 5. Check for at least one special character
		if (!/[!@#$%^&*()_+\-=\[\]{}|;:,.<>?/~`]/.test(password)) {
			errors.push('Password must contain at least one special character');
		}

		// 6. Check for forbidden words (case-insensitive)
		const lowerPassword = password.toLowerCase();
		for (const word of this.forbiddenWords) {
			if (lowerPassword.includes(word.toLowerCase())) {
				errors.push(`Password cannot contain company-related words like "${word}"`);
				break; // Only report once
			}
		}

		this.passwordValidationErrors = errors;
	}

	changeUserPassword() {
		let mode = 'change';
		if(this.pageName == 'reset_password')
			mode = 'reset';

		this.homeService.changeUserPassword(this.user, mode, this.URLparameters.enc).subscribe(
			(response: any) => {
				if(response.httpStatus == 'success') {
					this.notificationMessage.setMessage(response.msg, 'success', 10000, true);
					this.authService.logoutUser().subscribe((authenticated: boolean) => {
						this.router.navigate(['/login']);
					});
				} else if(response.httpStatus == 'error') {

					this.notificationMessage.setMessage(response.msg);
				}
			}
		);
	}

	sendResetLink() {
		this.homeService.sendExpiredPasswordReset(this.user.id).subscribe((response: any) => {
			if (response.httpStatus == 'success') {
				this.resetLinkSent = true;
				this.notificationMessage.setMessage(response.msg, 'success', 10000, true);
			} else if (response.httpStatus == 'error') {
				this.notificationMessage.setMessage(response.msg);
			}
		});
	}

	ngOnDestroy() {
		this.breadcrumb.hide();
		if(this.pageName == 'reset_password' || this.mode == 'register'){
			this.header.show();
			this.navigation.setPreviousUrl(null, true); // Remove Previous URL
		}
	}
}
